import { gql } from '@apollo/client'

export const ASSIGN_BROADSIGN_CREATION_MEDIA = gql`
  mutation AssignBroadsignCreationMedia($id: ID!, $media: [BroadsignCreationMediumUsage!]!) {
    assignBroadsignCreationMedia(input: { id: $id, media: $media }) {
      broadsignCreation {
        id
        media {
          asId
        }
      }
      errors
      success
    }
  }
`
